import { Component, EventEmitter, Input, Output } from "@angular/core";
import "./breadcrumbs.scss";

export interface IBreadcrumb<T = any> {
    title: string;
    data?: T;
}

@Component({
    selector: "breadcrumbs",
    template: require("./breadcrumbs.html")
})
export class BreadcrumbsComponent{
    @Input() breadcrumbs: IBreadcrumb[];
    @Output() onClick: EventEmitter<any> = new EventEmitter();

    constructor() { }

    emitBreadcrumb(crumb: IBreadcrumb, index: number) {
        this.onClick.emit({ crumb, index });
    }
}

//class Controller implements angular.IComponentController, IComponentBindings {
//    breadcrumbs: IBreadcrumb[];
//    onClick: (args: { $crumb: IBreadcrumb, $index: number }) => void;

//    static $inject = [];

//    constructor() {
//    }

//    $onChanges(onChangesObj: angular.IOnChangesObject): void {
//    }

//    // ---
//}

//export class BreadcrumbsComponent implements angular.IComponentOptions {
//    bindings: any;
//    template: string;
//    controller: any;

//    constructor() {
//        this.bindings = {
//            breadcrumbs: "<",
//            onClick: "&"
//        };

//        this.controller = Controller;

//        this.template = require("./breadcrumbs.html");
//    }
//}
